/**
 * Per-group identity colours for the left nav (app-sidebar.tsx).
 *
 * Established 2026-05-22 as part of the QAM brand refresh
 * (~/Productivity/QAM/design-refresh-continuation.md). Each sidebar group
 * carries the identity colour of the surface it leads to, so an active nav
 * item reads in that surface's accent:
 *
 *   - Delivery QA   → blue   (#2563EB — the QA accent used across qa-detail-v3)
 *   - Active Tasks  → teal   (#0E7490 — the dark cyan identity on activetask-list)
 *   - Pre-Screen    → purple (#592F96 — Starling brand purple, prescreen identity)
 *   - Admin         → purple (#592F96 — brand default for generic chrome)
 *
 * `accent` is used for the active item's text, icon, and left accent bar.
 * `tintBg` is the active item's background fill. Pure data + lookup so the
 * mapping can be unit-tested without rendering (repo has no jsdom).
 */

export type NavGroupKey = "delivery-qa" | "active-tasks" | "pre-screen" | "model-measurement" | "training" | "admin";

export interface NavIdentity {
  /** Text, icon, and left accent-bar colour for the active item. */
  accent: string;
  /** Background fill for the active item. */
  tintBg: string;
}

export const NAV_IDENTITY: Record<NavGroupKey, NavIdentity> = {
  "delivery-qa": { accent: "#2563EB", tintBg: "rgba(37, 99, 235, 0.10)" },
  "active-tasks": { accent: "#0E7490", tintBg: "rgba(14, 116, 144, 0.10)" },
  "pre-screen": { accent: "#592F96", tintBg: "rgba(89, 47, 150, 0.12)" },
  "model-measurement": { accent: "#B45309", tintBg: "rgba(180, 83, 9, 0.10)" },
  // SPEC-TrainingSimulator — Training group (brand purple, like Pre-Screen).
  training: { accent: "#592F96", tintBg: "rgba(89, 47, 150, 0.12)" },
  admin: { accent: "#592F96", tintBg: "rgba(89, 47, 150, 0.12)" },
};

export function navIdentity(key: NavGroupKey): NavIdentity {
  return NAV_IDENTITY[key];
}
